export enum RewardSettingStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  FINISH = 'FINISH',
}

export enum RewardSettingStatusString {
  PENDING = 'dijadwalkan',
  ACTIVE = 'aktif',
  FINISH = 'selesai',
}
